module.exports = __webpack_public_path__ + "img/celula_procariota.bc011746.jpg";